/**
 * 全部资源
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../base/BaseComponent";
import {Modal, Button, Table, Pagination, Tooltip, Input} from "antd";
import PublicResource from './components/PublicResource'
const {confirm} = Modal;

export default class SchoolResource extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {

        super(props);
        this.state = {

        }
    }

    componentWillMount() {

    }

    componentDidMount() {

    }

    render() {

        return (
            <PublicResource name={this.props.match.params.Resources}  type={1}></PublicResource>
        )
    }
}